/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ClientObject } from '../../params/redux/client';
import CustomInput from '../reusable/input';
import { editDealSecondPhaseSchema } from '../../schema/deal_schema';
import LabelWrapper from '../wrapper/label';
import { settingEditClientFlag } from '../../redux/slices/client';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { DealEditStepTwoParams, DealObject } from '../../params/pipeline';
import { Form, Formik } from 'formik';
import { setEditDeal, setInitialDealStepValues, setSecondStepDetailsOfDeal } from '../../redux/slices/deal';
import { useDispatch, useSelector } from 'react-redux';

interface EditStepTwoProps {
    setActiveStep: (values: DealEditStepTwoParams) => void;
    cancelHandler: () => void;
}

const getInitialValues = (selectedDeal: DealObject, selectedClient: ClientObject, flags: { isEditClient: boolean }, updateDealValues: DealEditStepTwoParams, id: number) => {
    if (flags.isEditClient && location.pathname.includes(`/app/client/${id}/dashboard`)) {
        return {
            deal_website: updateDealValues?.deal_website ?? selectedClient?.client_socials?.website ?? '',
            deal_facebook: updateDealValues?.deal_facebook ?? selectedClient?.client_socials?.facebook ?? '',
            deal_twitter: updateDealValues?.deal_twitter ?? selectedClient?.client_socials?.twitter ?? '',
            deal_linkedin: updateDealValues?.deal_linkedin ?? selectedClient?.client_socials?.linkedin ?? '',
            deal_instagram: updateDealValues?.deal_instagram ?? selectedClient?.client_socials?.instagram ?? '',
            deal_mobile_friendly: updateDealValues?.deal_mobile_friendly ?? selectedClient?.client_socials?.mobile_friendly ?? 0,
            deal_ssl: updateDealValues?.deal_ssl ?? selectedClient?.client_socials?.deal_ssl ?? 0,
            deal_wordpress: updateDealValues?.deal_wordpress ?? selectedClient?.client_socials?.wordpress ?? 0,
            deal_shopify: updateDealValues?.deal_shopify ?? selectedClient?.client_socials?.shopify ?? 0,
            deal_facebook_pixel: updateDealValues?.deal_facebook_pixel ?? selectedClient?.client_socials?.facebook_pixel ?? 0,
            deal_business_type: updateDealValues?.deal_business_type ?? (parseInt(selectedClient?.client_socials?.business_type as string, 10) as 0 | 1) ?? 0,
            deal_with_analytics: updateDealValues?.deal_with_analytics ?? selectedClient?.client_socials?.with_analytics ?? 0,
            deal_google_analytics: updateDealValues?.deal_google_analytics ?? selectedClient?.client_socials?.google_analytics ?? 0,
            deal_seo_schema: updateDealValues?.deal_seo_schema ?? selectedClient?.client_socials?.seo_schema ?? 0,
            deal_yelp: updateDealValues?.deal_yelp ?? selectedClient?.client_socials?.yelp ?? 0,
            deal_google_remaketing: updateDealValues?.deal_google_remaketing ?? selectedClient?.client_socials?.google_remarketing ?? 0
        };
    }
    return {
        deal_website: updateDealValues?.deal_website ?? selectedDeal?.deal_socials?.website ?? '',
        deal_facebook: updateDealValues?.deal_facebook ?? selectedDeal?.deal_socials?.facebook ?? '',
        deal_twitter: updateDealValues?.deal_twitter ?? selectedDeal?.deal_socials?.twitter ?? '',
        deal_linkedin: updateDealValues?.deal_linkedin ?? selectedDeal?.deal_socials?.linkedin ?? '',
        deal_instagram: updateDealValues?.deal_instagram ?? selectedDeal?.deal_socials?.instagram ?? '',
        deal_mobile_friendly: updateDealValues?.deal_mobile_friendly ?? selectedDeal?.deal_socials?.mobile_friendly ?? 0,
        deal_ssl: updateDealValues?.deal_ssl ?? selectedDeal?.deal_socials?.deal_ssl ?? 0,
        deal_wordpress: updateDealValues?.deal_wordpress ?? selectedDeal?.deal_socials?.wordpress ?? 0,
        deal_shopify: updateDealValues?.deal_shopify ?? selectedDeal?.deal_socials?.shopify ?? 0,
        deal_facebook_pixel: updateDealValues?.deal_facebook_pixel ?? selectedDeal?.deal_socials?.facebook_pixel ?? 0,
        deal_business_type: updateDealValues?.deal_business_type ?? (parseInt(selectedDeal?.deal_socials?.business_type as string, 10) as 0 | 1) ?? 0,
        deal_with_analytics: updateDealValues?.deal_with_analytics ?? selectedDeal?.deal_socials?.with_analytics ?? 0,
        deal_google_analytics: updateDealValues?.deal_google_analytics ?? selectedDeal?.deal_socials?.google_analytics ?? 0,
        deal_seo_schema: updateDealValues?.deal_seo_schema ?? selectedDeal?.deal_socials?.seo_schema ?? 0,
        deal_yelp: updateDealValues?.deal_yelp ?? selectedDeal?.deal_socials?.yelp ?? 0,
        deal_google_remaketing: updateDealValues?.deal_google_remaketing ?? selectedDeal?.deal_socials?.google_remarketing ?? 0
    };
};

const EditStepTwo = ({ setActiveStep, cancelHandler }: EditStepTwoProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const { loaders, updateDealValues, selectedDeal } = useSelector((state: RootState) => state.deal);
    const { flags, selectedClient, loaders: clientLoaders } = useSelector((state: RootState) => state.client);

    const initialValues: DealEditStepTwoParams = getInitialValues(
        selectedDeal as DealObject,
        selectedClient as ClientObject,
        flags,
        updateDealValues?.secondStep as DealEditStepTwoParams,
        id as unknown as number
    );

    const handleSubmit = (values: DealEditStepTwoParams) => {
        setActiveStep(values);
    };

    const handlePreviousStep = (values: DealEditStepTwoParams) => {
        dispatch(setSecondStepDetailsOfDeal(values));
        cancelHandler();
    };

    const handleCancel = () => {
        dispatch(settingEditClientFlag(false));
        dispatch(setInitialDealStepValues());
        dispatch(setEditDeal(false));
    };

    return (
        <Box>
            <Typography variant="h5" align="center" gutterBottom>
                Update Social Info
            </Typography>
            <Formik initialValues={initialValues} validationSchema={editDealSecondPhaseSchema} onSubmit={handleSubmit}>
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
                    <Form>
                        <Box display="flex" flexDirection="column" gap="20px">
                            <Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <LabelWrapper label="Website" />
                                    <Box display="flex" gap="20px">
                                        <CustomInput
                                            type="checkbox"
                                            name="mobile_friendly"
                                            label="Mobile-Friendly"
                                            checked={values.deal_mobile_friendly === 1}
                                            onChange={(e) => setFieldValue('deal_mobile_friendly', e.target.checked ? 1 : 0)}
                                            onBlur={handleBlur('deal_mobile_friendly')} disabled={loaders.isUpdating}
                                            error={touched.deal_mobile_friendly && Boolean(errors.deal_mobile_friendly)}
                                        />
                                        <CustomInput
                                            type="checkbox"
                                            name="ssl"
                                            label="SSL"
                                            checked={values.deal_ssl === 1}
                                            onChange={(e) => setFieldValue('deal_ssl', e.target.checked ? 1 : 0)}
                                            onBlur={handleBlur('deal_ssl')} disabled={loaders.isUpdating}
                                            error={touched.deal_ssl && Boolean(errors.deal_ssl)}
                                        />
                                        <CustomInput
                                            type="checkbox"
                                            name="wordpress"
                                            label="Wordpress"
                                            checked={values.deal_wordpress === 1}
                                            onChange={(e) => setFieldValue('deal_wordpress', e.target.checked ? 1 : 0)}
                                            onBlur={handleBlur('deal_wordpress')} disabled={loaders.isUpdating}
                                            error={touched.deal_wordpress && Boolean(errors.deal_wordpress)}
                                        />
                                        <CustomInput
                                            type="checkbox"
                                            name="shopify"
                                            label="Shopify"
                                            checked={values.deal_shopify === 1}
                                            onChange={(e) => setFieldValue('deal_shopify', e.target.checked ? 1 : 0)}
                                            onBlur={handleBlur('deal_shopify')} disabled={loaders.isUpdating}
                                            error={touched.deal_shopify && Boolean(errors.deal_shopify)}
                                        />
                                    </Box>
                                </Box>
                                <CustomInput
                                    fullWidth
                                    placeholder="Type here"
                                    name="website"
                                    value={values.deal_website}
                                    variant="outlined"
                                    onChange={handleChange('deal_website')}
                                    onBlur={handleBlur('deal_website')} disabled={loaders.isUpdating}
                                    error={touched.deal_website && Boolean(errors.deal_website)}
                                />
                            </Box>
                            <Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <LabelWrapper label="Facebook" />
                                    <Box>
                                        <CustomInput
                                            type="checkbox"
                                            name="facebook_pixel"
                                            label="Facebook Pixel"
                                            checked={values.deal_facebook_pixel === 1}
                                            onChange={(e) => setFieldValue('deal_facebook_pixel', e.target.checked ? 1 : 0)}
                                            onBlur={handleBlur('deal_facebook_pixel')} disabled={loaders.isUpdating}
                                            error={touched.deal_facebook_pixel && Boolean(errors.deal_facebook_pixel)}
                                        />
                                    </Box>
                                </Box>
                                <CustomInput
                                    fullWidth
                                    placeholder="Type here"
                                    name="facebook"
                                    value={values.deal_facebook}
                                    onChange={handleChange('deal_facebook')}
                                    onBlur={handleBlur('deal_facebook')}
                                    variant="outlined" disabled={loaders.isUpdating}
                                    error={touched.deal_facebook && Boolean(errors.deal_facebook)}
                                />
                            </Box>
                            <Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <LabelWrapper label="Instagram" />
                                    <Box>
                                        <CustomInput
                                            type="checkbox"
                                            name="business_type"
                                            label="Business-Type"
                                            checked={values.deal_business_type === 1}
                                            onChange={(e) => setFieldValue('deal_business_type', e.target.checked ? 1 : 0)}
                                            onBlur={handleBlur('deal_business_type')} disabled={loaders.isUpdating}
                                            error={touched.deal_business_type && Boolean(errors.deal_business_type)}
                                        />
                                    </Box>
                                </Box>
                                <CustomInput
                                    fullWidth
                                    placeholder="Type here"
                                    name="instagram"
                                    value={values.deal_instagram}
                                    onChange={handleChange('deal_instagram')}
                                    onBlur={handleBlur('deal_instagram')}
                                    variant="outlined" disabled={loaders.isUpdating}
                                    error={touched.deal_instagram && Boolean(errors.deal_instagram)}
                                />
                            </Box>
                            <Box>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <LabelWrapper label="LinkedIn" />
                                    <Box>
                                        <CustomInput
                                            type="checkbox"
                                            name="analytics"
                                            label="With Analytics"
                                            checked={values.deal_with_analytics === 1}
                                            onChange={(e) => setFieldValue('deal_with_analytics', e.target.checked ? 1 : 0)}
                                            onBlur={handleBlur('deal_with_analytics')} disabled={loaders.isUpdating}
                                            error={touched.deal_with_analytics && Boolean(errors.deal_with_analytics)}
                                        />
                                    </Box>
                                </Box>
                                <CustomInput
                                    fullWidth
                                    placeholder="Type here"
                                    name="linkedin"
                                    value={values.deal_linkedin}
                                    onChange={handleChange('deal_linkedin')}
                                    onBlur={handleBlur('deal_linkedin')}
                                    variant="outlined" disabled={loaders.isUpdating}
                                    error={touched.deal_linkedin && Boolean(errors.deal_linkedin)}
                                />
                            </Box>
                            <CustomInput
                                fullWidth
                                label="Twitter"
                                placeholder="Type here"
                                name="twitter"
                                value={values.deal_twitter}
                                onChange={handleChange('deal_twitter')}
                                onBlur={handleBlur('deal_twitter')}
                                variant="outlined" disabled={loaders.isUpdating}
                                error={touched.deal_twitter && Boolean(errors.deal_twitter)}
                            />
                            <Box>
                                <LabelWrapper label="Others" />
                                <Box display="flex" justifyContent="start" alignItems="center" gap="10px">
                                    <CustomInput
                                        type="checkbox"
                                        name="google_analytics"
                                        label="Google Analytics"
                                        checked={values.deal_google_analytics === 1}
                                        onChange={(e) => setFieldValue('deal_google_analytics', e.target.checked ? 1 : 0)}
                                        onBlur={handleBlur('deal_google_analytics')} disabled={loaders.isUpdating}
                                        error={touched.deal_google_analytics && Boolean(errors.deal_google_analytics)}
                                    />
                                    <CustomInput
                                        type="checkbox"
                                        name="seo"
                                        label="SEO Schema"
                                        checked={values.deal_seo_schema === 1}
                                        onChange={(e) => setFieldValue('deal_seo_schema', e.target.checked ? 1 : 0)}
                                        onBlur={handleBlur('deal_seo_schema')} disabled={loaders.isUpdating}
                                        error={touched.deal_seo_schema && Boolean(errors.deal_seo_schema)}
                                    />
                                    <CustomInput
                                        type="checkbox"
                                        name="yelp"
                                        label="Yelp"
                                        checked={values.deal_yelp === 1}
                                        onChange={(e) => setFieldValue('deal_yelp', e.target.checked ? 1 : 0)}
                                        onBlur={handleBlur('deal_yelp')} disabled={loaders.isUpdating}
                                        error={touched.deal_yelp && Boolean(errors.deal_yelp)}
                                    />
                                    <CustomInput
                                        type="checkbox"
                                        name="google_remarketing"
                                        label="Google Remarketing"
                                        checked={values.deal_google_remaketing === 1}
                                        onChange={(e) => setFieldValue('deal_google_remaketing', e.target.checked ? 1 : 0)}
                                        onBlur={handleBlur('deal_google_remaketing')} disabled={loaders.isUpdating}
                                        error={touched.deal_google_remaketing && Boolean(errors.deal_google_remaketing)}
                                    />
                                </Box>
                            </Box>
                            <Box display="flex" justifyContent="flex-end" gap="10px">
                                <Button variant="outlined" color="secondary" onClick={handleCancel} disabled={loaders.isUpdating || clientLoaders.isUpdating}>
                                    Cancel
                                </Button>
                                <Button variant="outlined" color="secondary" onClick={() => handlePreviousStep(values)} disabled={loaders.isUpdating || clientLoaders.isUpdating}>
                                    Previous
                                </Button>
                                <Button type="submit" variant="contained" color="primary" disabled={loaders.isUpdating || clientLoaders.isUpdating}>
                                    Confirm
                                </Button>
                            </Box>
                        </Box>
                    </Form>
                )}
            </Formik>
        </Box>);
};

export default EditStepTwo;